import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authStatusSelector } from 'redux-data/auth/selectors';
import useHasValueChanged from 'react-hooks/useHasValueChanged';
import { connectToSocket, disconnectFromSocket } from './actionCreators';
const useSocket = (config) => {
    const authStatus = useSelector(authStatusSelector);
    const hasAuthStatusChanged = useHasValueChanged(authStatus);
    const hasUserIdChanged = useHasValueChanged(config.user_id);
    const dispatch = useDispatch();
    // prevents recconects on token refresh
    const shouldConnect = authStatus === 'ready' &&
        (hasAuthStatusChanged || hasUserIdChanged) &&
        config.access_token &&
        config.user_id;
    useEffect(() => {
        shouldConnect && dispatch(connectToSocket(config));
        return () => {
            dispatch(disconnectFromSocket(config.type));
        };
    });
};
export default useSocket;
//# sourceMappingURL=useSocket.js.map